/**
 * Activity Calendar — Type Definitions
 * Shared component types for the reusable calendar grid.
 */

export type EventCategory = 'painting' | 'sculpting' | 'drawing' | 'programming' | 'sports' | 'music';

export type CalendarView = 'daily' | 'weekly' | 'monthly';

export interface CalendarEvent {
  id: number;
  title: string;
  startTime: string; // "07:00" — 24-hour format
  endTime: string;   // "08:00"
  date: string;      // "2026-05-04" — ISO date string
  category: EventCategory;
  color?: string;    // Custom identity_color from activity — overrides category color
  participantCount?: number;
}

export interface CalendarDay {
  date: Date;
  dayName: string;
  dayNumber: number;
  isToday: boolean;
  events: CalendarEvent[];
}

/**
 * Category color config matching Figma design.
 * "light" events use translucent fill + colored right border + dark text.
 * "solid" events use opaque background + white text.
 */
export interface CategoryColorConfig {
  bg: string;
  border: string;
  text: string;
  variant: 'light' | 'solid';
}

export const EVENT_CATEGORY_COLORS: Record<EventCategory, CategoryColorConfig> = {
  painting:     { bg: 'rgba(124,231,220,0.7)', border: '#07c0ac', text: '#414042', variant: 'light' },
  sculpting:    { bg: 'rgba(170,204,255,0.7)', border: '#3f8dff', text: '#414042', variant: 'light' },
  drawing:      { bg: 'rgba(222,181,255,0.7)', border: '#c67eff', text: '#414042', variant: 'light' },
  programming:  { bg: '#ff7f0e', border: '#ff7f0e', text: '#FFFFFF', variant: 'solid' },
  sports:       { bg: '#17becf', border: '#17becf', text: '#FFFFFF', variant: 'solid' },
  music:        { bg: '#e377c2', border: '#e377c2', text: '#FFFFFF', variant: 'solid' },
};
